import { render, staticRenderFns } from "./mapping_list.vue?vue&type=template&id=6b7db63a"
import script from "./mapping_list.vue?vue&type=script&lang=js"
export * from "./mapping_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports